import React, { useState } from "react";
import { getForgotPasswordLink } from "../../../services/auth-service/authService";
import { FORGOT_PASSWORD_REDEIRECT_ROUTE } from "../../../configs/routes/redirectRoutes";
import { toastError, toastSuccess } from "../../../utils/toast";

interface ForgotPasswordPopupProps {
  onClose: () => void;
}

function ForgotPasswordPopup({ onClose }: ForgotPasswordPopupProps) {
  const [email, setEmail] = useState("");

  async function handleSubmit() {
    try {
      await getForgotPasswordLink({
        email,
        redirect_url: FORGOT_PASSWORD_REDEIRECT_ROUTE,
      });
      toastSuccess("Password reset link sent to your email!");
      onClose();
    } catch (error: any) {
      toastError(error.response?.data?.message ?? "Failed to send reset link");
    }
  }

  return (
    /* Backdrop */
    <div
      onClick={onClose}
      style={{
        position:        "fixed",
        inset:           0,
        background:      "rgba(0,0,0,0.45)",
        zIndex:          1050,
        display:         "flex",
        alignItems:      "center",
        justifyContent:  "center",
        padding:         "1rem",
      }}
    >
      {/* Dialog — stop click propagation so clicking inside doesn't close */}
      <div
        onClick={e => e.stopPropagation()}
        style={{
          width:        "100%",
          maxWidth:     400,
          background:   "#ffffff",
          borderRadius: 16,
          boxShadow:    "0 8px 40px rgba(0,0,0,0.18)",
          overflow:     "hidden",
        }}
      >
        {/* Header */}
        <div style={{ padding: "1.25rem 1.5rem 1rem", borderBottom: "1px solid #f1f5f9", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h5 style={{ margin: 0, fontWeight: 700, color: "#1e293b" }}>Forgot your password?</h5>
          <button
            onClick={onClose}
            style={{ background: "none", border: "none", fontSize: "1.25rem", color: "#94a3b8", cursor: "pointer", lineHeight: 1, padding: "0 0 0 0.5rem" }}
            aria-label="Close"
          >×</button>
        </div>

        {/* Body */}
        <div style={{ padding: "1.25rem 1.5rem" }}>
          <label style={{ fontSize: "0.875rem", color: "#475569", marginBottom: "0.5rem", display: "block" }}>
            Enter your email address to get a password reset link
          </label>
          <input
            type="email"
            className="form-control"
            placeholder="name@example.com"
            value={email}
            onChange={e => setEmail(e.target.value)}
            onKeyDown={e => e.key === "Enter" && handleSubmit()}
            autoFocus
          />
        </div>

        {/* Footer */}
        <div style={{ padding: "0.75rem 1.5rem 1.25rem", display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
          <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
          <button className="btn btn-danger text-white" onClick={handleSubmit}>Submit</button>
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordPopup;
